
import { Component, OnInit, Input, ViewEncapsulation, HostListener, ChangeDetectorRef } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent, PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import { AuthService } from '../../../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'pg-menu-items',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('toggleHeight', [
      state('close', style({
        height: '0',
        overflow: 'hidden',
        marginBottom: '0',
        display: 'none',

      })),
      state('open', style({
        display: 'block',
        height: '*',
        marginBottom: '10px',
        // overflow: 'hidden',
      })),
      transition('close => open', animate('140ms ease-in')),
      transition('open => close', animate('140ms ease-out'))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {
  menuItems = [];
  currentItem = null;
  isPerfectScrollbarDisabled = false
  public config: PerfectScrollbarConfigInterface = {};
  constructor(
    private authService: AuthService,
    private router: Router,
    private cdr : ChangeDetectorRef
  ) { }

  ngOnInit() {
    for (let i of this.menuItems) {
      i.toggle = 'close';
    }
  }

  isActive(url,exact?) {
    let routerUrl = this.router.url.toLowerCase().split("?")[0];
    if(routerUrl.startsWith("/")){
      routerUrl = routerUrl.substring(1,routerUrl.length);
    }
    try{
      if(!exact){
        routerUrl = routerUrl.split("/")[0];
        if(routerUrl.startsWith("/")){
          routerUrl = routerUrl.substring(1,routerUrl.length);
        }
        let isExact = routerUrl == url.toLowerCase();
        if (isExact) {
          return true;
        }
      }
      else{
        if(routerUrl.startsWith("/")){
          routerUrl = routerUrl.substring(1,routerUrl.length);
        }
        let isExact = routerUrl == url.toLowerCase();
        if (isExact) {
          return true;
        }
      }
    }
    catch(err){

    }
    return false;
  }

  childIsActive(item){
    if(item["toggle"] == 'open'){
      return false;
    }
    if(item.submenu){
      for(let menuItem of item.submenu){
        let routerUrl = this.router.url.toLowerCase();
        if(routerUrl.startsWith("/")){
          routerUrl = routerUrl.substring(1,routerUrl.length);
        }
        if(routerUrl == menuItem.routerLink){
          return true;
        }
      }
    }
    return false;
  }

  openLink(item) {
    let _this = this;
    // if (optItem) {
    //   optItem['toggle'] = optItem['toggle'] == 'open' ? 'close' : 'open';
    // }
    // if (item == undefined || item == '/undefined') {
    //   return;
    // }
    // if (item.charAt(0) != '/') {
    //   item = "/" + item;
    // }
    // this.router.navigate([item]);
    // if(item['submenu']){
    //   item['toggle'] = 'open';
    //   setInterval(() => {
    //     console.log(item);
    //     try{
    //       _this.cdr.detectChanges();
    //     }
    //     catch(err){
          
    //     }
    //   },1000);
    // }
  }

  logout() {
    this.authService.signout();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.togglePerfectScrollbar();
    })
  }

  @HostListener("window:resize", [])
  onResize() {
    this.togglePerfectScrollbar();
  }

  togglePerfectScrollbar() {
    this.isPerfectScrollbarDisabled = window.innerWidth < 1025
  }

  @Input()
  set Items(value) {
    this.menuItems = value
  }

  switch(item) {
    if (this.menuItems[item].toggle !== 'open') {
      this.menuItems[item].toggle = 'open';
    }
    else {
      this.menuItems[item].toggle = 'close';
    }
  }

  toggleNavigationSub(event, item) {
    event.preventDefault();
    if (this.currentItem && this.currentItem != item) {
      this.currentItem["toggle"] = 'close';
    }
    this.currentItem = item;
    item.toggle = (item.toggle === 'close' ? 'open' : 'close');
  }
}
